export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/male_singer.716f622.svg";